/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { isNone } from '@ember/utils';
import chunk from 'lodash.chunk';
import ClipboardJS from 'clipboard';
import { saveAs } from 'file-saver';
import { print } from 'cio/utils/print';
import { Task } from 'ember-concurrency';

interface BackupCodesArgs {
  codes: string[];
  generateNewBackupCodesTask?: Task<unknown, []>;
  onCopy?: () => unknown;
  onDownload?: () => unknown;
  onPrint?: () => unknown;
}

export default class BackupCodes extends Component<BackupCodesArgs> {
  readonly columns = 2;

  @tracked clipboard!: ClipboardJS;

  get codes() {
    return (
      this.args.codes ?? [
        '1234567890',
        '0987654321',
        '1234567890',
        '0987654321',
        '1234567890',
        '0987654321',
        '1234567890',
        '0987654321',
        '1234567890',
        '0987654321',
      ]
    );
  }
  get codesRows() {
    return chunk(this.codes, this.columns);
  }

  @action
  copy() {
    let { onCopy } = this.args;

    if (onCopy) {
      onCopy();
    }
  }
  @action
  download() {
    let { onDownload } = this.args;
    let blob = new Blob([this.codes.join('\n')]);

    if (onDownload) {
      onDownload();
    }

    return saveAs(blob, 'cio_backups.txt');
  }
  @action
  print() {
    let { onPrint } = this.args;

    if (onPrint) {
      onPrint();
    }

    return print(this.codes.join('<br>'));
  }

  @action
  onInsert(element: HTMLElement) {
    let clipboardButton = element.querySelector('.js-clipboard-button');
    if (clipboardButton) {
      this.clipboard = new ClipboardJS(clipboardButton, {
        text: () => this.codes.join('\n'),
      });
    }
  }
  @action
  onDestroy() {
    let { clipboard } = this;
    if (!isNone(clipboard)) {
      clipboard.destroy();
    }
  }
}
